import React from 'react'
import logger from '../../../../../utils/logger'

export const AccountMoreInfo = ({ memberData }) => {

  logger.debug('memberData moreInfo: ', memberData)

  return (
    <>
      <div className="mp-user-dto d-flex">
        <h4 className="mp-header-nav-title">Mas Información</h4>


        {memberData?.formationPlaces[0]?.name &&
          <div className="modal-info-container">
            <div className="mp-location-tpa bg-colorW">
              <div className="iLocation-container">
                <span className="material-symbols-outlined notranslate mI-subscription" aria-hidden="true" role="none">location_on</span>
              </div>
              <div className="infoLocation-container">
                <p className="p-location-title">Ubicación/es Preferida/s para la Fase Presencial</p>
                <hr />
                <p className="p-ubication">• {memberData?.formationPlaces[0].name}</p>
              </div>
            </div>


            {memberData?.howMet &&
              <div className="mp-knowing-tpa bg-colorW">
                <div className="iHandshake-container">
                  <span className="material-symbols-outlined notranslate mI-subscription" aria-hidden="true" role="none">handshake</span>
                </div>
                <div className="knowing-info ">
                  <p className="p-knowing-title">Cómo Conociste TPA® y Decidiste Unirte</p>
                  <hr />
                  <p className="p-how">• {memberData?.howMet}</p>
                </div>
              </div>
            }

            

          </div>
        }

        {memberData?.yearOfEnrollment &&


          <div className="mp-today-tpa">

            <div className="iToday-container">
              <span className="material-symbols-outlined notranslate mI-subscription" aria-hidden="true" role="none">today</span>
            </div>


            <div className="year-container">
              <p className="p-year-title">Año en el que realizó la Formación Profesional TPA®</p>
              <hr />
              <p className="p-year">{memberData?.yearOfEnrollment}</p>
            </div>

          </div>




        }



      </div>



    </>

  )
}
